<template>
  <div class="login-wrapper">
    <!-- Alert Component -->
    <AlertComponent />
    
    <v-container fluid class="login-container fill-height">
      <div class="login-background"></div>
      <div class="login-overlay"></div>
      
      <v-row justify="center" align="center">
        <v-col cols="12" sm="8" md="6" lg="4">
          <v-card 
            class="login-card elevation-10" 
            :class="{ 'animate-card': animateCard }"
            rounded="lg"
          >
            <v-card-text class="text-center pt-8">
              <!-- Logo at the top -->
              <div class=" mb-6">
                <img 
                  src="@/assets/logo.png" 
                  alt="شعار النظام"
                  class="logo-image"
                  :class="{ 'animate-logo': animateLogo }"
                />
              </div>
              
              <!-- Title and subtitle -->
              <div class="text-center mb-8">
                <h1 class="text-h5 font-weight-bold primary--text mb-2">منظومة المراسلات</h1>
                <!-- <p class="text-subtitle-1 text-medium-emphasis">المركز الوطني لمكافحة الأمراض</p> -->
              </div>
              
              <!-- Centered form -->
              <v-form @submit.prevent="handleLogin" ref="loginForm" class="login-form">
                <v-text-field
                  v-model="username"
                  label="اسم المستخدم"
                  prepend-inner-icon="mdi-account"
                  variant="outlined"
                  required
                  :rules="[v => !!v || 'يرجى إدخال اسم المستخدم']"
                  class="rtl-field mb-4"
                  :disabled="isLoading"
                  autocomplete="username"
                ></v-text-field>
                
                <v-text-field
                  v-model="password"
                  label="كلمة المرور"
                  prepend-inner-icon="mdi-lock"
                  variant="outlined"
                  type="password"
                  required
                  :rules="[v => !!v || 'يرجى إدخال كلمة المرور']"
                  class="rtl-field mb-2"
                  :disabled="isLoading"
                  autocomplete="current-password"
                ></v-text-field>
               
                
                <v-alert
                  v-if="errorMessage"
                  type="error"
                  variant="tonal"
                  class="mb-4 text-right"
                  density="compact"
                >
                  {{ errorMessage }}
                </v-alert>
                
                <v-btn
                  type="submit"
                  color="primary"
                  block
                  size="large"
                  class="mt-2 login-button"
                  :loading="isLoading"
                  :disabled="isLoading"
                  elevation="2"
                >
                  تسجيل الدخول
                </v-btn>
              </v-form>
            </v-card-text>
            
            <v-card-actions class="justify-center pb-6">
              <p class="text-caption text-medium-emphasis">
                © {{ new Date().getFullYear() }} المركز الليبي لمكافحة الأمراض. جميع الحقوق محفوظة
              </p>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AlertComponent from '@/components/AlertComponent.vue'

export default {
  name: 'LoginComponent',
  components: {
    AlertComponent
  },
  data() {
    return {
      username: '',
      password: '',
      errorMessage: '',
      isLoading: false,
      rememberMe: false,
      animateCard: false,
      animateLogo: false
    }
  },
  mounted() {
    // Trigger animations after component is mounted
    setTimeout(() => {
      this.animateCard = true
      
      setTimeout(() => {
        this.animateLogo = true
      }, 500)
    }, 100)
  },
  methods: {
    ...mapActions(['login']),
    async handleLogin() {
      // Reset error message
      this.errorMessage = ''
      
      // Validate form
      const { valid } = await this.$refs.loginForm.validate()
      
      if (!valid) {
        this.errorMessage = 'يرجى إدخال اسم المستخدم وكلمة المرور'
        return
      }
      
      // Start loading
      this.isLoading = true
      
      try {
        await this.login({
          username: this.username,
          password: this.password
        })
        
        this.$alerts.success('تم تسجيل الدخول بنجاح')
        this.$router.push('/dashboard/inbox')
      } catch (error) {
        console.error('Login error:', error)
        // Show error message
        this.$alerts.error(error.message || 'فشل في تسجيل الدخول')
      } finally {
        // Always reset loading state
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.login-wrapper {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  font-family: 'Cairo', sans-serif;
}

.login-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('https://images.unsplash.com/photo-1557683316-973673baf926?q=80&w=2029&auto=format&fit=crop');
  background-size: cover;
  background-position: center;
  filter: blur(0px);
  z-index: -2;
}

.login-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(87, 93, 144, 0.9) 0%, rgba(62, 66, 102, 0.85) 100%);
  z-index: -1;
}

.login-container {
  position: relative;
  z-index: 1;
}

.login-card {
  border-radius: 16px;
  overflow: hidden;
  transform: translateY(30px);
  opacity: 0;
  transition: all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
  font-family: 'Cairo', sans-serif;
}

.animate-card {
  transform: translateY(0);
  opacity: 1;
}

.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 70%;
  height: 120px;
 
  
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.logo-image {
  width: 70%;
  
  object-fit: contain;
  transform: scale(0.8);
  opacity: 0;
  transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.animate-logo {
  transform: scale(1) !important;
  opacity: 1 !important;
}

.login-form {
  max-width: 400px;
  margin: 0 auto;
}

.rtl-field :deep(.v-field__prepend-inner) {
  margin-left: 8px;
  margin-right: 0;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center !important;
}

.login-button {
  transition: transform 0.3s ease;
  font-family: 'Cairo', sans-serif;
}

.login-button:hover {
  transform: translateY(-2px);
}

/* Apply font to all text elements */
h1, p, label, button, input, .v-alert, .v-checkbox {
  font-family: 'Cairo', sans-serif !important;
}

/* Add subtle animation to the background */
@keyframes gradientAnimation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.login-overlay {
  animation: gradientAnimation 15s ease infinite;
  background-size: 200% 200%;
}
</style> 